export const ME_LOAD_REQUEST = 'ME_LOAD_REQUEST';
export const ME_LOAD_SUCCESS = 'ME_LOAD_SUCCESS';
export const ME_LOAD_FAILURE = 'ME_LOAD_FAILURE';
